export const OPTHINES = {
  voteName: '/2019poject/2019pharmacy/',
  buttonBg: '#d72620',
  mustSearch: 'Button',
  number: {
    mustRank: true,
  },
  name: true,
  content: true,
  user: true,
  themeColor: {
    activeBgColor: '#0081c7',
    inactiveBgColor: '#45b8f7',
  },
  tickets: {
    textFirst: '票数',
    textLast: '票',
  },
  tabs: [
    {
      tabName: '活动首页',
      tabPath: '/2019CQYFJ/FirstPage',
    },
    {
      tabName: '我要报名',
      tabPath: '/2019CQYFJ/Register',
    },
    // {
    //   tabName: '推荐报名',
    //   tabPath: '/2019CQYFJ/Recommend',
    // },
    {
      tabName: '相关新闻',
      tabPath: '/2019CQYFJ/NewsPage',
    },
    {
      tabName: '评选说明',
      tabPath: '/2019CQYFJ/Rules',
    },
  ],
  healthType: [
    {
      fullName: '重庆连锁药房十大领军品牌  （10强）',
      shortName: '重庆连锁药房十大领军品牌  （10强）',
    },
    {
      fullName: '重庆连锁药房十大领军人物（10强）',
      shortName: '重庆连锁药房十大领军人物（10强）',
    },
    {
      fullName: '重庆百强放心药店（100强）',
      shortName: '重庆百强放心药店（100强）',
    },
    {
      fullName: '重庆百强金牌药师（100强）',
      shortName: '重庆百强金牌药师（100强）',
    },
  ],
};
